import { createModalRootComponent } from '../../../common/modals/framework/components/modal-root';

export default createModalRootComponent({
  importModals: () =>
    import(
      /* webpackChunkName: "feed-page-modals" */ './modal-component-map-by-type'
    ),
});
